import create from 'zustand'

import { ReportStoreState, ReportTab } from './types'
import { Country } from '../../types'
import { CascaderOptionType } from 'antd/lib/cascader'

export const noFilterOption = { label: 'NO FILTER', value: 'NO FILTER', key: 'noFilter' }
export const allCountriesOption = { label: Country.All, value: Country.All, key: Country.All }

const initialValues = {
  storeInitialized: false,
  activeTab: undefined,
  countries: [],
  mappedCountries: [],
  selectedCountry: noFilterOption,
}

export const useReportStore = create<ReportStoreState>((set) => ({
  ...initialValues,

  initStore: (_countries: Country[], _activeTab: ReportTab, _countriesWhereReportGenerationIsEnabled: Country[] | undefined) =>
    set(() => {
      const sortedCountries = [..._countries].sort((c1, c2) => c1.localeCompare(c2))
      const mappedCountries: CascaderOptionType[] = sortedCountries.map((country) => ({
        label: country,
        value: country,
        key: country,
      }))
      if (
        _countriesWhereReportGenerationIsEnabled &&
        _countriesWhereReportGenerationIsEnabled.every((country) => _countries.indexOf(country) !== -1)
      ) {
        mappedCountries.unshift(allCountriesOption)
      }
      mappedCountries.unshift(noFilterOption)
      return {
        storeInitialized: true,
        countries: sortedCountries,
        mappedCountries: mappedCountries,
        activeTab: _activeTab,
      }
    }),

  setActiveTab: (activeTab: ReportTab) =>
    set((state) => {
      state.activeTab = activeTab
      return { ...state }
    }),

  setSelectedCountry: (selectedCountry: string) =>
    set((state) => {
      state.selectedCountry = { label: selectedCountry, value: selectedCountry, key: selectedCountry }
      return { ...state }
    }),

  setMappedCountries: (options: CascaderOptionType[]) => set({ mappedCountries: options }),
}))
